import angular from 'angular';
import contextProvider from './context.provider';


const timingStrategyService = angular.module('ttb.services.timingStrategy.service', [
  contextProvider,
])
  .factory('timingStrategyService', ['$q', '$http', 'context','$translate',
    ($q, $http, context,$translate) => {
      let currentCalcRequestId = null;

      function toModel(response) {
        const activity = response.data;

        const durationMinutes = activity.durationMinutes;
        const days = activity.days;

        const startTime = new Date(activity.startTime);
        const endTime = new Date(activity.endTime);
        const childDurationMinutes = activity.childDurationMinutes;
        const activitySubItems = activity.activitySubItems;
        const categoryId = activity.categoryId;
        const availableSprints = activity.availableSprints;
        const sprintId = activity.sprintId;

        if(activity.unableToMeetEdgesAndTotal)
        {
          ttb.Notifications.ShowStatusConsistencyMessage( $translate.instant('Activity_Calculation_Warn_Title'), $translate.instant('Activity_Calculation_Warn_Description'),10000)
        }

        return {
          durationMinutes,
          days,
          startTime,
          endTime,
          childDurationMinutes,
          activitySubItems,
          categoryId,
          availableSprints,
          sprintId
        };
      }

      function toTemplate(response) {
        const activity = response.data;

        const userWorkingConfig = activity.userWorkingConfig;
        const teamId = activity.teamId;
        const issueId = activity.issueId;
        const issueType = activity.issueType;
        const parentItemType = activity.parentItemType;
        const assignTo = activity.assignTo;
        const endTime = new Date(activity.endTime);
        const availableUsers = activity.availableUsers;
        const priorityId = activity.priorityId;
        const createdDate = activity.createdDate;
        const sprintId = activity.sprintId;
        const availableSprints = activity.availableSprints;
        const activityStatus = activity.activityStatus;
        const projectItemTypeConfigId = activity.projectItemTypeConfigId;
        
         return {
          endTime,
          issueId,
          teamId,
          userWorkingConfig,
          issueType,
          parentItemType,
          assignTo,
          availableUsers,
          priorityId,
          createdDate,
          sprintId,
          availableSprints,
          activityStatus,
          projectItemTypeConfigId
        };
      }

        function calculate(id, { startTime, endTime, durationMinutes, days, calculationFor, issueId, teamId, issueType, parentItemType, assignedTo, sprintId, activityStatus, categoryId, priorityId, createdDate,projectItemTypeConfigId, userWorkingConfig }) {
        currentCalcRequestId = Math.random();
        return $q((resolve, reject) => {
          const calcRequestId = currentCalcRequestId;
          context.getProject()
            .then((project) => {
              if (calcRequestId !== currentCalcRequestId) {
                reject(new Error('abort request'));
                return;
              }

              $http.post(`/api/activity-log/${project.group}/${project.name}/calculate`,
                {
                  startTime,
                  endTime,
                  durationMinutes,
                  days,
                  issueType,
                  parentItemType,
                  assignedTo,
                  sprintId,
                  activityStatus,
                  priorityId,
                  createdDate,
                  categoryId,
                  projectItemTypeConfigId,
                  userWorkingConfig
                },
                {
                  params: {
                    id,
                    issueId,
                    teamId,
                    calculationFor
                  },
                })
                .then((data) => {
                  if (calcRequestId !== currentCalcRequestId) {
                    reject(new Error('abort request'));
                    return;
                  }
                  resolve(toModel(data));
                }, reject);
            }, reject);
        });
      }

      function getCalculationTemplate(issueId, teamId) {
        return $q((resolve, reject) => {
          context.getProject()
            .then((project) => {
              $http.get(`/api/activity-log/${project.group}/${project.name}/creation-template`, { params: { issueId , teamId} })
                .then((data) => {
                  resolve(toTemplate(data));
                }, reject);
            }, reject);
        });
      }

      return {
        getCalculationTemplate,
        calculate,
      };
    }])
  .name;

export default timingStrategyService;



// WEBPACK FOOTER //
// ../services/timing-strategy.service.js